'use client';

import { c as _c } from "react/compiler-runtime";
import { FOCUS_RING } from '@common/components/interaction';
import SvgFireFill from '@common/icon/SvgFireFill';
import { cn } from '@core/utils';
import { Fragment } from 'react';
import { AD_PLACEMENTS } from '@/app/_components/ads/adPlacements';
import { BannerAdSlot } from '@/app/_components/ads/BannerAdSlot';
import type { NativeAdSlotConfig } from '@/app/_components/ads/NativeAdSlot';
import { TREND_TOP_RANKING_MAX } from './constants';
import { TrendRankChange } from './TrendRankChange';
import type { TrendKeywordItem } from './useTrendKeywords';
const AD_AFTER_RANKING: Record<number, NativeAdSlotConfig | undefined> = {
  5: AD_PLACEMENTS.trendKeywordRank5
};

//* 10위 슬롯은 "뒤"가 아니라 11위 "앞"에 건다 — PC는 11위부터 다음 페이지라 뒤에 걸면 광고만 이전 페이지에 남는다.
const AD_BEFORE_RANKING: Record<number, NativeAdSlotConfig | undefined> = {
  11: AD_PLACEMENTS.trendKeywordRank10
};
const SIZE_STYLE = {
  mobile: {
    row: 'h-52 pl-8 pr-12',
    keyword: 'typo-body4',
    fire: 'size-16',
    //* PC 시안만 상승 화살표를 강조색으로 쓴다 — 모바일은 기존 회색 유지.
    upArrow: undefined,
    topRank: undefined
  },
  desktop: {
    row: 'h-44 p-12',
    keyword: 'typo-caption1',
    fire: 'size-14',
    upArrow: 'text-B-300',
    topRank: 'text-B-550'
  }
} as const;
interface TrendKeywordPanelProps {
  keywords: TrendKeywordItem[];
  onSelect: (keyword: string) => void;
  size: keyof typeof SIZE_STYLE;
  className?: string;
}
export const TrendKeywordPanel = t0 => {
  const $ = _c(14);
  const {
    keywords,
    onSelect,
    size,
    className
  } = t0;
  const style = SIZE_STYLE[size];
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== keywords || $[3] !== onSelect || $[4] !== size || $[5] !== style) {
    let t3;
    if ($[7] !== onSelect || $[8] !== size || $[9] !== style) {
      t3 = item => {
        const leadingAd = AD_BEFORE_RANKING[item.ranking];
        const trailingAd = AD_AFTER_RANKING[item.ranking];
        return <Fragment key={item.keyword}>{leadingAd && <BannerAdSlot {...leadingAd} wrapperClassName="flex shrink-0 justify-center py-8" />}<button className={cn("flex w-full shrink-0 items-center justify-between rounded-small", style.row, "transition-colors duration-150 hover:bg-Gray-25 active:bg-Gray-50 motion-reduce:transition-none", FOCUS_RING)} aria-label={`${item.ranking}위 ${item.keyword} 검색`} onClick={() => onSelect(item.keyword)}><span className="flex min-w-0 items-center gap-8"><span className={cn("min-w-16 shrink-0 font-500 typo-body4", style.topRank && item.ranking <= TREND_TOP_RANKING_MAX ? style.topRank : "text-Gray-700")}>{item.ranking}</span><span className="flex min-w-0 items-center gap-4"><span className={cn("truncate font-600 text-Gray-black", style.keyword)}>{item.keyword}</span>{item.spikeYN && <SvgFireFill className={cn("shrink-0 text-O-400", style.fire)} />}</span></span><TrendRankChange rankChange={item.rankChange} isNew={item.newYN} size={size} upIconClassName={style.upArrow} /></button>{trailingAd && <BannerAdSlot {...trailingAd} wrapperClassName="flex shrink-0 justify-center py-8" />}</Fragment>;
      };
      $[7] = onSelect;
      $[8] = size;
      $[9] = style;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = keywords.map(t3);
    $[2] = keywords;
    $[3] = onSelect;
    $[4] = size;
    $[5] = style;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[11] !== t1 || $[12] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};